"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debug = void 0;
exports.debug = process.env.NODE_ENV != 'production';
//# sourceMappingURL=config.js.map